<app-loading *ngIf="contentReady"></app-loading>

<div class="bb-page">
  <div class="bb-page-shell">

    <!-- Header -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
                                          <span class="bb-eyebrow">{{ 'myclients' | transloco }}</span>
        <h2 class="bb-page-title">{{ "myclients" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "Manage your clients" | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        <button type="button" (click)="goToCreateClient()" class="bb-btn bb-btn-primary">
          {{ "create client" | transloco }}
        </button>

        @if(isAdmin){
        <div class="dropdown bb-action-dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
            {{ "Pospage" | transloco }}
          </button>

          <ul class="dropdown-menu bb-dropdown-menu">
            <li *ngFor="let el of allWareHouses">
              <a class="dropdown-item bb-dropdown-item" (click)="applyWareHouse(el.id)">
                {{el.name}}
              </a>
            </li>
          </ul>
        </div>
        }

      </div>
    </div>

    <!-- Card -->
    <div class="bb-filter-card">

      <!-- Debit Section -->
      @if(isWarehouse){
      <div class="bb-bulk-bar">
        <span class="bb-text-blue bb-font-bold">
          {{ 'Total Outstanding Balance' | transloco }} : {{ totaldebit * -1 }} {{ 'egpe' | transloco }}
        </span>
      </div>
      }

      <!-- Search -->
      <div class="search-row">
        <div class="search-box">
          <input type="text" class="bb-input" [(ngModel)]="searchKey" placeholder="{{ 'Phone Number' | transloco }}">

          <button class="bb-btn bb-btn-primary" (click)="search()">
            {{ 'Search' | transloco }}
          </button>
        </div>
      </div>

    </div>

    <!-- Table -->
    <div class="bb-table-card">
      <div class="bb-table-scroll">
        <table mat-table id="orderstable" [dataSource]="dataSource" class="bb-table">

          <!-- Client Name -->
          <ng-container matColumnDef="client_name">
            <th mat-header-cell *matHeaderCellDef>
              {{ "client name" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element" (click)="accStatement(element.phone_number)" class="bb-clickable-cell">

              <div class="bb-flex bb-items-center bb-gap-12">
                <div class="bb-client-avatar">
                  {{ element.client_name?.charAt(0) }}
                </div>

                <div class="bb-text-stack">
                  <div class="bb-product-title">
                    {{ element.client_name }}
                  </div>
                  <small>
                    {{ element.phone_number }}
                  </small>
                </div>
              </div>

            </td>
          </ng-container>

          <!-- Phone -->
          <ng-container matColumnDef="phone_number">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Phone Number' | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.phone_number }}
            </td>
          </ng-container>

          <!-- Another Phone -->
          <ng-container matColumnDef="another_phone">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Another Phone Number' | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.another_phone || '-' }}
            </td>
          </ng-container>

          <!-- Address -->
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>
              {{ "address" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.address }}
            </td>
          </ng-container>

          <!-- Orders -->
          <ng-container matColumnDef="orders">
            <th mat-header-cell *matHeaderCellDef class="bb-text-center"></th>
            <td mat-cell *matCellDef="let element" class="bb-text-center">
              <button class="bb-icon-btn bb-client-action-btn bb-client-action-info" (click)="getClientOrders(element.orders)"
                title="{{ 'clientorders' | transloco }}">
                <img src="/assets/cart.png" [alt]="'orders' | transloco">
              </button>
            </td>
          </ng-container>

          <!-- Products -->
          <ng-container matColumnDef="stocks">
            <th mat-header-cell *matHeaderCellDef class="bb-text-center"></th>
            <td mat-cell *matCellDef="let element" class="bb-text-center">
              <button class="bb-icon-btn bb-client-action-btn bb-client-action-primary" (click)="getClientproducts(element.stocks)"
                title="{{ 'clientproducts' | transloco }}">
                <img src="/assets/quanity.png" [alt]="'products' | transloco">
              </button>
            </td>
          </ng-container>

          <!-- Reorder -->
          <ng-container matColumnDef="reorder">
            <th mat-header-cell *matHeaderCellDef class="bb-text-center"></th>
            <td mat-cell *matCellDef="let element" class="bb-text-center">
              <button class="bb-icon-btn bb-client-action-btn bb-client-action-warning" (click)="reOrder(element)"
                title="{{ 'add order' | transloco }}">
                <img src="/assets/reorder.png" [alt]="'reorder' | transloco">
              </button>
            </td>
          </ng-container>

          <!-- Add Pet -->
          <ng-container matColumnDef="addpet">
            <th mat-header-cell *matHeaderCellDef class="bb-text-center"></th>
            <td mat-cell *matCellDef="let element" class="bb-text-center">
              <button class="bb-icon-btn bb-client-action-btn bb-client-action-success" (click)="addPet(element.id)" routerLink="/Addpet"
                title="{{ 'add pet' | transloco }}">
                <img src="/assets/addpet.png" [alt]="'add pet' | transloco">
              </button>
            </td>
          </ng-container>

          <!-- Call -->
          <ng-container matColumnDef="call">
            <th mat-header-cell *matHeaderCellDef class="bb-text-center"></th>
            <td mat-cell *matCellDef="let element" class="bb-text-center">
              <button class="bb-icon-btn bb-client-action-btn bb-client-action-call" (click)="call(element.phone_number)"
                title="{{ 'call' | transloco }}">
                <img src="/assets/call.png" [alt]="'call' | transloco">
              </button>
            </td>
          </ng-container>

          <!-- Chat -->
          <ng-container matColumnDef="chat">
            <th mat-header-cell *matHeaderCellDef class="bb-text-center"></th>
            <td mat-cell *matCellDef="let element" class="bb-text-center">
              <button class="bb-icon-btn bb-client-action-btn bb-client-action-whatsapp" (click)="chat(element.phone_number)"
                title="{{ 'chat' | transloco }}">
                <img src="/assets/chat.png" [alt]="'chat' | transloco">
              </button>
            </td>
          </ng-container>

          <!-- Account Statement -->
          <ng-container matColumnDef="accountStatement">
            <th mat-header-cell *matHeaderCellDef class="bb-text-center"></th>
            <td mat-cell *matCellDef="let element" class="bb-text-center">
              <button class="bb-icon-btn bb-client-action-btn bb-client-action-secondary" (click)="accStatement(element.phone_number)"
                title="{{ 'accountStatement' | transloco }}">
                <img src="/assets/accstet.png" [alt]="'account statement' | transloco">
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>

        </table>
      </div>

      <mat-paginator class="bb-paginator" [length]="stockTotal" [pageSize]="10" (page)="onPaginateChange($event)">
      </mat-paginator>
    </div>

    <!-- No Data -->
    <div class="bb-empty-state" *ngIf="noData">
      <app-nodata></app-nodata>
    </div>

  </div>
</div>

<!-- Shared Popup -->
<div *ngIf="showClientPopup" class="bb-modal-backdrop popup" (click)="closeClientPopup()">
  <div class="bb-modal-card bb-client-popup-card popup-box" (click)="$event.stopPropagation()">

    <div class="bb-modal-header">
      <h4>{{ popupTitle }}</h4>
    </div>

    <div class="bb-grid bb-gap-16">

      <!-- Orders Popup -->
      <ng-container *ngIf="popupType === 'orders'">
        <div *ngIf="selectedOrders.length > 0; else noOrdersBlock" class="bb-grid bb-gap-12">
          <div *ngFor="let order of selectedOrders" class="bb-card bb-p-16 bb-client-popup-item">

            <div class="bb-flex bb-items-center bb-justify-between bb-gap-12 bb-wrap bb-mb-12">
              <div class="bb-badge bb-badge-primary">
                #{{ order.id }}
              </div>

              <div class="bb-badge bb-badge-soft-blue">
                <ng-container [ngSwitch]="order.order_status">
                  <span *ngSwitchCase="1">{{ "pending" | transloco }}</span>
                  <span *ngSwitchCase="2">{{ "approved" | transloco }}</span>
                  <span *ngSwitchCase="3">{{ "rejected" | transloco }}</span>
                  <span *ngSwitchCase="4">{{ "on the way" | transloco }}</span>
                  <span *ngSwitchCase="5">{{ "shipped" | transloco }}</span>
                  <span *ngSwitchCase="6">{{ "Deferred" | transloco }}</span>
                  <span *ngSwitchCase="7">{{ "notcontacttheclient" | transloco }}</span>
                  <span *ngSwitchCase="8">{{ "delivered" | transloco }}</span>
                </ng-container>
              </div>
            </div>

            <div class="bb-grid bb-gap-8" *ngIf="order.item?.length">
              <div class="bb-card bb-p-12 bb-client-product-row" *ngFor="let productName of order.item; let i = index">
                <div class="bb-flex bb-items-center bb-gap-8 bb-font-bold bb-text-navy">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 8l-9-5-9 5 9 5 9-5Z" />
                    <path d="M3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8" />
                    <path d="M12 13v9" />
                  </svg>
                  {{ productName }}
                </div>

                <div class="bb-flex bb-items-center bb-gap-12 bb-wrap bb-mt-8">
                  <span class="bb-badge bb-badge-soft-cyan">{{ 'Qty' | transloco }}: {{ order.quantity?.[i] || 0 }}</span>
                  <span class="bb-badge bb-badge-soft-blue">{{ 'Price' | transloco }}: {{ order.price?.[i] || 0 }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>

        <ng-template #noOrdersBlock>
          <div class="bb-empty-state">
            <div class="bb-flex bb-justify-center bb-mb-12">
              <span class="bb-upload-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M2 8l10 6 10-6" />
                  <path d="M4 6h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" />
                  <path d="M22 8l-10 6L2 8" />
                </svg>
              </span>
            </div>
            <p class="bb-m-0 bb-text-muted bb-font-semibold">{{ 'No orders yet' | transloco }}</p>
          </div>
        </ng-template>
      </ng-container>

      <!-- Products Popup -->
      <ng-container *ngIf="popupType === 'products'">
        <div *ngIf="selectedProducts.length > 0; else noProductsBlock" class="bb-grid bb-gap-12">
          <div *ngFor="let item of selectedProducts" class="bb-card bb-p-16 bb-client-popup-item">
            <div class="bb-text-stack">
              <div class="bb-flex bb-items-center bb-gap-8 bb-font-bold bb-text-navy">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 8l-9-5-9 5 9 5 9-5Z" />
                  <path d="M3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8" />
                  <path d="M12 13v9" />
                </svg>
                {{ isAr ? item.name_ar : (item.name_en || item.name_ar) }}
              </div>
              <small>
                {{ 'Type' | transloco }}: {{ getCategoryName(item.category_id) | transloco }}
              </small>
            </div>
          </div>
        </div>

        <ng-template #noProductsBlock>
          <div class="bb-empty-state">
            <div class="bb-flex bb-justify-center bb-mb-12">
              <span class="bb-upload-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M2 8l10 6 10-6" />
                  <path d="M4 6h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" />
                  <path d="M22 8l-10 6L2 8" />
                </svg>
              </span>
            </div>
            <p class="bb-m-0 bb-text-muted bb-font-semibold">{{ 'No products yet' | transloco }}</p>
          </div>
        </ng-template>
      </ng-container>

    </div>

    <div class="bb-modal-actions">
      <button (click)="closeClientPopup()" class="bb-btn bb-btn-secondary">
        {{ "close" | transloco }}
      </button>
    </div>

  </div>
</div>